import React from "react";
import Container from "react-bootstrap/Container";
import {Breadcrumb, Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";
import fomImg from "../img/FOM_logo.jpg";
import wccImg from "../img/wcc-logo-text.png";
import committeeImg from "../img/committee_low_res.JPG";


const About = () => {

    return (
        <>
            <Container fluid>
                <Row>
                    <Col>
                        <h3>
                            <Breadcrumb>
                                <Breadcrumb.Item active>About</Breadcrumb.Item>
                            </Breadcrumb>
                        </h3>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <p>
                            Winchester Porchfest is a free, one-day community music celebration where local musicians
                            perform on front porches, driveways, and patios across town. Audiences stroll from venue
                            to venue, discovering live music of every genre along the way — a beloved Winchester
                            tradition that brings neighbors together and showcases the incredible talent in our
                            community.
                        </p>
                        <p>
                            Porchfest is a <a href="https://fomwps.wixsite.com/winchester-music" target="_blank"
                                              rel="noreferrer">Friends of Music</a> initiative, organized and run by
                            local volunteers, and funded in part by a grant from
                            the <a href="https://winchesterculturalcouncil.org/" target="_blank"
                                   rel="noreferrer">Winchester Cultural Council</a>.
                        </p>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <a href="https://fomwps.wixsite.com/winchester-music" target="_blank" rel="noreferrer"
                           className="about-sponsor">
                            <img src={fomImg} alt="Winchester Friends of Music"/>
                        </a>
                        <a href="https://winchesterculturalcouncil.org" target="_blank" rel="noreferrer"
                           className="about-sponsor">
                            <img src={wccImg} alt="Winchester Cultural Council"/>
                        </a>
                    </Col>
                </Row>
                <br/>
                <Row className="mb-3">
                    <Col>
                        <h5>The Committee</h5>
                        <p>Your Winchester Porchfest Committee, aka "The Porch Stars":</p>

                        <ul>
                            <li>Fred Yen (Winchester Farmers Market)</li>
                            <li>Laurie Russell (Winchester Community Music School)</li>
                            <li>Shukong Ou and Peter Pulsifer (Winchester Cultural Council)</li>
                            <li>
                                Salma Abounadi, Omar Baba, Shiva Barton, Debbie Catalano, Catherine
                                Curtis, Keith Doo, Susan Rozmanith (At-large)
                            </li>
                            <li>
                                Gina Altaras, Kaleem Baba, Nadeem Baba, George Gilmer (Alumni)
                            </li>
                        </ul>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <img src={committeeImg} alt="The 2025 Porch Stars" className="img-fluid"/>
                        <p className="text-muted mt-2"><small>The 2025 Porch Stars</small></p>
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <h5>Join Us!</h5>
                        <p>
                            Porchfest is a labor of love, and we're always looking for enthusiastic people to help
                            make it happen. Whether you have ideas to share, time to lend, or just a passion for live
                            music and community — we'd love to hear from you. Reach out on
                            our <Link to="/contact" reloadDocument="true">contact</Link> page and get involved. The
                            more, the merrier!
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default About;
